import React, { Component } from 'react';
import { Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import split from 'lodash/split';
import isEqual from 'lodash/isEqual';
import api from '../../api';

export class Thumbnail extends Component {
  state = {
    url: undefined,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEqual(nextProps.src, prevState.src)) {
      return { src: nextProps.src };
    }
    return null;
  }

  componentDidMount() {
    const { src, defaultVideoSrc } = this.props;
    this.requestThumbnail(src)
      .then(url => {
        this.setState({ url });
      })
      .catch(() => this.setState({ url: defaultVideoSrc }));
  }

  componentDidUpdate(prevProps) {
    const { src, defaultVideoSrc } = this.props;
    if (!isEqual(prevProps.src, src)) {
      this.requestThumbnail(src)
        .then(url => {
          this.setState({ url });
        })
        .catch(() => this.setState({ url: defaultVideoSrc }));
    }
  }

  requestThumbnail = videoUrl => {
    if (includes(videoUrl, 'vimeo')) {
      const vimeoId = split(videoUrl, 'vimeo.com/').pop();
      return api.getVimeoThumbnail(vimeoId);
    } else if (includes(videoUrl, 'youtube')) {
      const youtubeId = split(videoUrl, 'youtube.com/watch?v=').pop();
      return api.getYoutubeThumbnail(youtubeId);
    }
    return Promise.reject();
  };

  render() {
    const { url } = this.state;
    const { className, style, defaultSrc, alt, rounded, fluid } = this.props;
    return (
      <Image
        className={className}
        style={style}
        src={url || defaultSrc}
        alt={alt}
        rounded={rounded}
        fluid={fluid}
      />
    );
  }
}

Thumbnail.propTypes = {
  src: PropTypes.string,
  defaultSrc: PropTypes.string,
  defaultVideoSrc: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  alt: PropTypes.string,
  rounded: PropTypes.bool,
  fluid: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Thumbnail/Thumbnail.js